import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Editor } from 'app/models';
import { environment } from 'environments/environment';

@Injectable()
export class EditorService {

  constructor(
    private httpClient: HttpClient
  ) { }

  // getAll(params: HttpParams | null = null): Observable<any> {
  //   return this.httpClient.get(`${environment.apiBaseUrl}v1/categories`, { params });
  // }
  //
  // get(id: number | string): Observable<any> {
  //   return this.httpClient.get(`${environment.apiBaseUrl}v1/editor/${id}`);
  // }
  //
  // post(model: Editor): Observable<any> {
  //   return this.httpClient.post(`${environment.apiBaseUrl}v1/editor`, { Editor: model });
  // }
  //
  // put(model: Editor): Observable<any> {
  //   return this.httpClient.put(`${environment.apiBaseUrl}v1/editor/${model.id}`, { Editor: model });
  // }
  //
  // delete(id: number | string): Observable<any> {
  //   return this.httpClient.delete(`${environment.apiBaseUrl}v1/editor/${id}`);
  // }
}
